module.exports = __webpack_public_path__ + "images/58be6c177a56e2523ddd70a05ff19661-logo_white.png";